import { useCallback } from 'react';
import cn from 'bem-cn';

import { ScreenSize, useGetScreenSize } from '../../../../hooks';
import { List, Stack } from '../../../UI';

import type { ChallengePrizesProps, ChallengePrizeType } from './ChallengePrizes.types';
import { ChallengePrize } from './ChallengePrize';
import './ChallengePrizes.scss';

const b = cn('challenge-prizes');

const extractTagKey = (_: ChallengePrizeType, index: number) => `prize-${index}`;

export const ChallengePrizes = (props: ChallengePrizesProps) => {
    const { prizes, isCharity } = props;

    const screenSize = useGetScreenSize();
    const prizesLength = prizes?.length ?? 0;
    const isTouch = [ScreenSize.Mobile, ScreenSize.Tablet].includes(screenSize);
    const isUnfilled = isTouch ? prizesLength % 2 === 1 : prizesLength % 3 === 1;

    const renderPrizeItem = useCallback(
        (item: ChallengePrizeType, index: number) => {
            return (
                <ChallengePrize prize={item} last={isUnfilled && index === prizesLength - 1} isCharity={isCharity} />
            );
        },
        [isUnfilled, prizesLength, isCharity],
    );

    if (!prizes?.length) {
        return null;
    }

    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Призы для победителей</h2>
            <List
                direction="row"
                className={b('list', { unfilled: isUnfilled, charity: isCharity })}
                items={prizes}
                renderItem={renderPrizeItem}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
